import {ResolveFn} from '@angular/router';
import {inject} from '@angular/core';
import {WebHook} from '@models/generated.model';
import {WebhooksService} from '@services/api-services/webhooks.service';

export const webhookResolver: ResolveFn<WebHook> = (route, state) => {
    const service = inject(WebhooksService);
    return service.get$(Number(<string>route.paramMap.get('id')));
};
